// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/NeueFrutigerWorldW02-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: small;
}
html#root,
body#root,
#root#root {
  overflow: hidden;
}
body {
  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;
  overflow: hidden;
}
body * {
  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;
}
* {
  box-sizing: border-box;
}
@font-face {
  font-family: 'NeueFrutigerWorldW02-Regular';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.customToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: min-content !important;
}
.columnsPanelTrigger {
  min-height: min-content !important;
  min-width: min-content !important;
}
.filterPanelTrigger {
  min-height: min-content !important;
  min-width: min-content !important;
}
.category {
  height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 2px;
  overflow-y: auto;
}
.category .multi-numeric-icon {
  color: #ffa300;
}
.category .header-section {
  margin-left: 7px;
  width: 99%;
  box-sizing: border-box;
  margin-bottom: 2px;
}
.category .header-section .section-view {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.category .header-section .section-view .edit-view button {
  text-transform: capitalize;
}
.category .header-section .category-header-section {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  background: #f2f4f7;
  border-radius: 1px 1px 0px 0px;
  border: 1px solid #dde1e9;
  height: 35px;
  max-height: 35px;
  font-size: 12px !important;
  align-items: center;
}
.category .header-section .category-header-section .breacrum-header-section {
  width: 50%;
  display: flex;
  align-items: center;
}
.category .header-section .category-header-section .breacrum-header-section .css-1v5z4dq-MuiPaper-root-MuiCard-root {
  border: 0px;
}
.category .header-section .category-header-section .breacrum-header-section button {
  padding-top: 0px;
  padding-bottom: 0px;
  width: 100px;
  margin-right: 5px;
  margin-left: 0px;
  height: 33px;
  border-radius: 2px;
  text-transform: capitalize;
}
.category .header-section .category-header-section .breacrum-header-section .MuiPaper-root.MuiCard-root {
  border: 0px;
}
.category .header-section .category-header-section .breacrum-header-section nav {
  white-space: nowrap;
}
.category .categories-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  margin-left: 7px;
  width: 99%;
  flex: 1;
  min-height: 369px;
}
.category .categories-container .categories-panel {
  width: 560px;
  display: flex;
  flex-direction: column;
}
.category .categories-container .categories-panel h3 {
  margin-bottom: 8px;
}
.category .categories-container .categories-panel .categories-list {
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  max-height: calc(70vh - 150px);
}
.category .categories-container .droppable-zones {
  display: flex;
  gap: 20px;
  flex: 1;
}
.category .categories-container .droppable-zones > div {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.category .breadcrumb-card-section nav {
  display: flex;
  align-items: center;
  width: 100%;
}
.category .breadcrumb-card-section nav a {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: color 0.2s ease;
  font-size: 14px;
  padding: 4px 6px;
  border-radius: 4px;
  background-color: #f2f4f7;
}
.category .breadcrumb-card-section nav a.active {
  color: black;
  font-weight: 500;
}
.category .breadcrumb-card-section nav a.not-active {
  color: #595959;
}
.category .breadcrumb-card-section nav a.not-active:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.04);
}
.category .breadcrumb-card-section nav .MuiSvgIcon-root {
  color: #999;
  margin: 0 8px;
}
.category .category-content {
  display: flex;
  flex: 1;
  height: calc(100% - 100px);
  position: relative;
}
.category .left-pane,
.category .middle-pane,
.category .right-pane {
  position: relative;
}
.category .left-pane {
  --pane-width: 30%;
  width: var(--pane-width);
  min-width: 200px;
  height: 100%;
  border: 1px solid #eee;
  border-radius: 4px;
  margin-left: 8px;
}
.category .middle-pane {
  --pane-width: 35%;
  width: var(--pane-width);
  min-width: 200px;
  height: 96%;
}
.category .right-pane {
  --pane-width: 35%;
  width: var(--pane-width);
  min-width: 200px;
  height: 96%;
}
.category .resize-hor {
  resize: horizontal;
}
.category .disabled-view {
  opacity: 0.6;
  pointer-events: none;
}
.category .assigned-section-header,
.category .unassingned-section-header {
  border-bottom: 2px solid #eee;
  padding-left: 4%;
  font-weight: bold;
}
.category-item {
  position: relative;
}
.category-item.over:not(.invalid) {
  border: 2px solid #1474a4;
}
.category-item.invalid {
  border: 2px solid #ef4444;
  outline: none;
}
.category-item.hover:not(.invalid):not(.over) > div:first-child {
  outline: 2px dashed #1474a4;
}
.category-item .category-row {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.category-item .category-content {
  width: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.category-item .category-content.selected {
  background: transparent;
}
.category-item .category-content.selected .feature-name,
.category-item .category-content.selected .action-button {
  color: #1474a4;
  font-weight: 500;
}
.category-item .category-content.selected .drag-handle .feature-icon .category-icon {
  color: #1474a4 !important;
}
.category-item .category-content.selected .drag-handle .feature-icon .category-icon.multi-numeric-icon {
  color: #ffa300 !important;
}
.category-item .category-content.parent-selected .feature-name {
  color: #1474a4;
  font-weight: 500;
}
.category-item .category-content.parent-selected .drag-handle .feature-icon .category-icon {
  color: #1474a4 !important;
}
.category-item .category-content.parent-selected .drag-handle .feature-icon .category-icon.multi-numeric-icon {
  color: #ffa300 !important;
}
.category-item .category-title {
  display: flex;
  align-items: center;
  flex: 1;
}
.category-item .drag-handle {
  display: flex;
  align-items: center;
  flex: 1;
}
.category-item .feature-name {
  margin-left: 6px;
}
.category-item .category-actions-wrapper {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.category-item .subcategories {
  margin-left: 20px;
}
.droppable-zone {
  flex: 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  height: 98%;
}
.droppable-zone h3 {
  margin-bottom: 8px;
}
.droppable-zone h3.highlighted {
  color: #1474a4;
}
.droppable-zone .drop-area {
  padding: 15px;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  z-index: 1;
}
.droppable-zone .drop-area .items-container {
  flex: 1;
  overflow-y: auto;
}
.droppable-zone .drop-area.over:not(.invalid),
.droppable-zone .drop-area[data-highlight='true']:not([data-invalid='true']) {
  border: 2px solid #1474a4 !important;
  border-style: solid !important;
  background: transparent;
  z-index: 2;
  box-shadow: 0 0 0 1px rgba(20, 116, 164, 0.3);
}
.droppable-zone .drop-area.invalid,
.droppable-zone .drop-area[data-invalid='true'] {
  border: 2px solid #ef4444 !important;
  border-style: solid !important;
  background: transparent;
  z-index: 3;
  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.3);
}
.droppable-zone .drop-area .empty-message {
  color: #666;
  font-style: italic;
}
.draggable-sortable-item.dragging {
  cursor: grabbing;
  opacity: 0.4;
  background-color: #f0f6ff !important;
  border: 1px dashed #ccc;
  box-shadow: none;
  z-index: 1000 !important;
  pointer-events: none;
}
.draggable-sortable-item.sortable {
  border-radius: 4px;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.draggable-sortable-item.sortable .item-content {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}
.draggable-sortable-item.sortable .item-content .item-description {
  margin-right: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.draggable-sortable-item.sortable .item-content .item-code {
  flex-shrink: 0;
  white-space: nowrap;
  color: #666;
}
.draggable-sortable-item.sortable .item-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.draggable-sortable-item.sortable .item-actions .drag-handle {
  color: #666;
  font-size: 14px;
}
.draggable-sortable-item.draggable {
  border-radius: 4px;
  cursor: grab;
  display: flex;
  align-items: center;
}
.draggable-sortable-item.draggable .item-content {
  margin-left: 8px;
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}
.draggable-sortable-item.draggable .item-content .item-description {
  margin-right: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.draggable-sortable-item.draggable .item-content .item-code {
  flex-shrink: 0;
  white-space: nowrap;
  color: #666;
}
.draggable-sortable-item.disabled {
  opacity: 0.6;
  cursor: default;
  pointer-events: none;
  color: #888;
}
.draggable-sortable-item.disabled.sortable {
  background: #f7f9ff;
}
.draggable-sortable-item.disabled.draggable {
  background: #f5f5f5;
}
.draggable-sortable-item.inactive {
  opacity: 0.7;
  cursor: default;
  pointer-events: none;
}
.draggable-sortable-item.inactive .strikethrough {
  text-decoration: line-through;
}
.common-dialog-style .MuiPaper-root .MuiDialogTitle-root {
  background: #1474a4;
  color: #fff;
  padding: 7px;
  padding-left: 23px;
  cursor: move;
}
.common-dialog-style .MuiPaper-root .MuiBox-root {
  width: 100%;
}
.add-category-dialog .MuiPaper-root {
  width: 80%;
}
.drag-preview {
  padding: 2px 2px;
  border-radius: 4px;
  background: #1474a4;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  pointer-events: none;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 5px;
}
.drag-preview .item-code {
  opacity: 0.8;
  font-size: 12px;
}
[data-dnd-overlay] {
  z-index: 9999 !important;
}
.drag-overlay-content {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
}
.drag-overlay-content .item-name {
  font-weight: 500;
}
.drag-overlay-content .item-code {
  color: #666;
}
.auto-complete-searchbar {
  margin-top: 16px;
  display: flex;
}
.auto-complete-search-input {
  flex-basis: 90%;
}
.auto-complete-search-input .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-radius: 4px 0px 0px 4px !important;
}
.auto-complete-search-button {
  background: white;
  border-radius: 0px 4px 4px 0px !important;
  border: solid 2px #e2e2e2 !important;
  border-left: none !important;
}
.auto-complete-search-icon {
  font-size: 25px !important;
  color: #1474a4 !important;
}
.css-xnywni-MuiFormLabel-root-MuiInputLabel-root {
  top: 20px !important;
  position: relative !important;
}
.css-196bwzp-MuiPaper-root-MuiCard-root {
  background-color: #f2f4f7 !important;
}
.css-1umw9bq-MuiSvgIcon-root {
  width: 16px !important;
  height: 0.9em !important;
}
.header-large-icon {
  font-size: 1.7rem !important;
  line-height: 1;
}
.icon-with-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 24px;
}
.edit-view {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.icon-helper-text {
  font-size: 0.95rem;
  color: #1474a4;
  font-weight: 500;
  letter-spacing: 0.01em;
}
.css-nykz7-MuiTreeItem-content {
  padding: 4px 8px 0px 0px !important;
  gap: 0px !important;
}
.css-nykz7-MuiTreeItem-content.Mui-selected {
  background-color: revert !important;
}
.category-wrapper {
  padding-left: 0;
}
.category-wrapper[data-section-depth] {
  padding-left: calc(var(--category-depth, 0) * 20px);
}
.css-fojsl4-MuiTreeItem-content {
  gap: 0px !important;
}
.small-badge .MuiBadge-badge {
  font-size: 0.65rem;
  height: 16px;
  min-width: 16px;
  padding: 0 4px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #5a9dbf;
}
::-webkit-scrollbar-thumb:hover {
  background: #5a9dbf;
}
.footer {
  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: black;
  margin-right: 1px;
  display: flex;
  flex-direction: row;
}
.footer.root {
  display: flex;
  width: 100% !important;
  font-size: 12px;
}
.footer .env {
  margin-right: 1px;
  padding-right: 1px;
}
.footer .termsAndCondition {
  display: flex;
  flex-direction: row;
  margin-right: 1px;
}
.footer.bg-gray {
  background-color: #eeeeee;
}
.footer.bg-green {
  background-color: #93c47d;
}
.footer.bg-orange {
  background-color: #f7d368;
}
.footer.bg-yellow {
  background-color: #f3f66b;
}
.termsAndCondition-dialog .paperClass {
  width: 45%;
  height: 60vh;
}
.d-flex {
  display: flex;
}
.d-inline-flex {
  display: inline-flex;
}
.d-block {
  display: block;
}
.d-inline-block {
  display: inline-block;
}
.d-inline {
  display: inline;
}
.flex-row {
  flex-direction: row;
}
.flex-column {
  flex-direction: column;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.squareSize {
  width: 100%;
  height: 100%;
}
.w-0 {
  width: 0%;
}
.w-25 {
  width: 25%;
}
.w-50 {
  width: 50%;
}
.w-100 {
  width: 100% !important;
}
.w-auto {
  width: auto;
}
.w-25ch {
  width: '25ch';
}
.w-10 {
  width: 10%;
}
.w-20 {
  width: 20%;
}
.w-40 {
  width: 40%;
}
.w-45 {
  width: 45%;
}
.w-90 {
  width: 90%;
}
.mw-0 {
  max-width: 0%;
}
.mw-25 {
  max-width: 25%;
}
.mw-50 {
  max-width: 50%;
}
.mw-100 {
  max-width: 100%;
}
.mw-10 {
  max-width: 10%;
}
.h-0 {
  height: 0%;
}
.h-25 {
  height: 25%;
}
.h-50 {
  height: 50%;
}
.h-100 {
  height: 100% !important;
}
.h-90vh {
  height: 90vh !important;
}
.h-auto {
  height: auto;
}
.h-inherit {
  height: inherit;
}
.m-0 {
  margin: 0;
}
.mt-0 {
  margin-top: 0;
}
.mt-1em {
  margin-top: 1em !important;
}
.mr-0 {
  margin-right: 0;
}
.mr-5px {
  margin-right: 5px !important;
}
.mb-0 {
  margin-bottom: 0;
}
.mb-05em {
  margin-bottom: 0.5em !important;
}
.ml-0 {
  margin-left: 0;
}
.ml-1 {
  margin-left: 1% !important;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.p-0 {
  padding: 0px !important;
}
.p-1 {
  padding: 1px !important;
}
.p-3px {
  padding: 3px !important;
}
.p-5px {
  padding: 5px;
}
.p-10px {
  padding: 10px !important;
}
.p-20px {
  padding: 20px;
}
.p-15px {
  padding: 15px;
}
.p-1rem {
  padding: 1rem;
}
.pt-0 {
  padding-top: 0 !important;
}
.pt-1 {
  padding-top: 1em !important;
}
.pr-1 {
  padding-right: 1em !important;
}
.pl-0 {
  padding-left: 0;
}
.pr-0 {
  padding-right: 0;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pb-1 {
  padding-bottom: 1em !important;
}
.float-right {
  float: right;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-right: 0;
  padding-left: 0;
}
.overflow-auto {
  overflow: auto;
}
.overflowX-auto {
  overflow-x: auto;
}
.overflowY-auto {
  overflow-y: auto;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.text-bold {
  font-weight: bold;
}
.ws-nowrap {
  white-space: nowrap !important;
}
.vertical-middle {
  vertical-align: middle;
}
.align-top {
  align-items: flex-start;
}
.align-center {
  align-items: center;
}
.alignself-center {
  align-self: center;
}
.alignself-start {
  align-self: self-start;
}
.justify-left {
  justify-content: left !important;
}
.justify-center {
  justify-content: center;
}
.justify-right {
  justify-content: right;
}
.justify-end {
  justify-content: flex-end;
}
.justify-spacebetween {
  justify-content: space-between;
}
.justify-start {
  justify-content: flex-start;
}
.cursor-move {
  cursor: move;
}
.warning {
  color: #f7d368 !important;
}
.bottomUnset {
  border-bottom: unset;
}
.rowFlex {
  display: flex;
  flex-direction: row;
}
.colFlex {
  display: flex;
  flex-direction: column;
}
.flex-start {
  justify-content: flex-start;
  align-items: flex-start;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default !important;
}
.position-absolute {
  position: absolute;
}
.overflow-hidden {
  overflow: hidden;
}
.textWidth50 {
  width: 50%;
  display: inline-block;
}
.overflowY-hidden {
  overflow-y: hidden;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.overflowWrap-anywhere {
  overflow-wrap: anywhere;
}
.zindex-100 {
  z-index: 100;
}
.zindex-2000 {
  z-index: 2000;
}
.border-radius-0 {
  border-radius: 0 !important;
}
.bg-philips-blue {
  background-color: #1474a4;
}
.bg-lightgray {
  background-color: lightgray;
}
.b-0 {
  border: 0;
}
.philipsBlue {
  color: #1474a4 !important;
}
.PhilipsRed {
  color: red;
}
.zoom80 {
  zoom: 80%;
}
.appRouter.root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding: 0;
}
.appRouter .secondaryHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 38px;
}
.appRouter .secondaryHeader .headername {
  padding: 10px !important;
  display: flex;
  color: #1474a4;
  font-weight: bold;
  font-size: 14px;
}
.appRouter .secondaryHeaderTabs {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
}
.appRouter .appRouterContent {
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  overflow: hidden;
  width: -webkit-fill-available;
}
.appRouter .divider {
  width: 100%;
}
.termsAndConditionStyle {
  display: flex;
  flex-direction: row;
  margin-right: 1px;
}
.termsAndConditionStyle .title {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}
.headerStyle.root {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.headerStyle .toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  min-height: 3rem;
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
}
.headerStyle .toolbarSection {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.headerStyle .tooltip {
  margin: 2;
}
.headerStyle .button-icon {
  cursor: pointer;
  color: #ffffff;
}
.userPanelIconButton {
  cursor: pointer;
  color: white !important;
  padding: 5px !important;
}
.userPanelIconButton .userProfileIcon {
  height: 2rem;
  width: 2rem;
}
.popperStyle.arrow {
  width: 3em;
  height: 3em;
}
.popperStyle::before {
  content: '';
  margin: auto;
  display: block;
  width: 0%;
  border-style: solid;
  border-width: 0px 1em 1em;
  border-color: transparent transparent #ffffff;
  margin-top: -0.4rem;
}
.middle-container {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100% !important;
  padding: 0.5em 1em;
}
.middle-container .mainHeader {
  margin-top: 0em;
  margin-bottom: 0.2em;
}
.common-dialog-paper {
  width: 550px !important;
  min-width: 550px !important;
}
.common-dialog-style .header {
  background-color: #1474a4;
  font-size: 1.2rem;
  padding: 0.5rem;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
  text-align: left !important;
}
.common-dialog-style .paper {
  height: 60vh;
}
.common-dialog-style .dialogContent {
  padding-top: 4vh !important;
}
.common-dialog-style .closeIcon {
  position: absolute;
  right: 0px;
  top: 0px;
  color: white;
}
.landing-Page-body {
  display: block;
  width: 100%;
  height: 100%;
}
.header4 {
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
}
.catalog-Container {
  width: 376px;
  height: 100px;
  padding: 5px;
}
.catalog-cardLayout {
  display: flex;
  padding: 10px !important;
}
.catalog-image {
  height: 80px;
  width: 80px;
  margin-left: 5px;
  margin-top: 5px;
}
.catalog-info {
  flex-basis: 90%;
  padding: 5px;
}
.catalog-productDescription {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 34ch;
}
.noData-label {
  width: 50%;
  margin-left: 45%;
  padding-top: 15%;
}
.catalog-icon {
  display: flex;
  flex-basis: 10%;
  padding: 5px;
  cursor: pointer;
}
.catalog-create {
  background-color: #1474a4 !important;
}
.productCatalogCardHeader {
  color: #1474a4;
  font-weight: bold;
}
.list-Section {
  display: block;
  height: calc(90% - 8.6rem);
  padding: 0px 10px 10px 10px;
  overflow-y: auto;
  overflow-x: hidden;
}
.list-Section ul > div {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.list-Section-Tab {
  display: block;
  width: 100%;
  height: 100%;
}
.list-Items {
  padding-top: 0px !important;
}
.list-Section::-webkit-scrollbar {
  height: 10px;
}
.list-ItemsContainer {
  margin-left: 0px !important;
  padding: 5px;
}
.recordsPerPage {
  height: 30px;
  margin-right: 15px;
}
.recordsPerPage > div {
  padding: 8.5px !important;
}
.refresh-button {
  min-height: min-content !important;
  min-width: min-content !important;
  padding: 6px 8px;
  position: relative !important;
}
.procos-export-button {
  margin-left: 30px !important;
  text-transform: none !important;
}
.pcs-export-button {
  margin-left: 40px !important;
  text-transform: none !important;
}
.refresh-button > span {
  padding-right: 2px;
  margin: 0px !important;
}
.export-button > span {
  margin: 4px !important;
}
.recordsChange-conatiner {
  display: flex;
  flex-direction: row-reverse;
  margin-right: 10px;
  align-items: center;
}
.recordsChange-conatiner .form-control {
  width: 5.5rem;
  margin-left: 10px;
}
.Records {
  display: flex;
  justify-content: flex-end;
}
.home-icon {
  color: #1474a4 !important;
  width: 100%;
  padding: 3px !important;
  margin: 0px !important;
}
.action-icon {
  color: #1474a4 !important;
  margin: 0px !important;
  padding: 2px !important;
}
.action-icon-disabled {
  color: #eeeeee !important;
  margin: 0px !important;
  padding: 3px !important;
}
.form-text {
  color: red !important;
}
.breadCrumb.root {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 10px;
}
.breadCrumb .item {
  color: #1474a4 !important;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  font-size: 1rem;
  font-weight: bold;
}
.breadCrumb .activeItem {
  font-weight: bold;
}
.search-bar.MuiAutocomplete-root {
  width: 20em !important;
  position: relative;
  bottom: 3px;
  right: 20px;
  padding-top: 0.3rem;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  margin-left: 0.7vw;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div > div > button {
  visibility: visible !important;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div > div > svg {
  position: absolute !important;
  top: 1.1vh !important;
  left: 0.2vw !important;
}
.unsupported-browser {
  display: inline-block;
  text-align: center;
  width: 45%;
  height: 90%;
  margin-left: auto;
  margin-right: auto;
}
.unsupported-browser .message {
  text-align: left;
  padding-top: 5px !important;
}
.unsupported-browser .unsupported-browser-image {
  height: 50;
  width: 40;
}
.unsupported-browser .versionSupported {
  z-index: 150000 !important;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.unsupported-browser .versionSupported .browserBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 2%;
  justify-content: space-between;
}
.unsupported-browser .versionSupported .browserBox img {
  height: 35px;
  width: 35px;
}
.unsupported-browser .versionSupported .browserBox .browserDetails {
  display: flex;
  flex-direction: column;
}
.activeIcon {
  color: #eeeeee !important;
  background-color: #1474a4 !important;
}
.languageContainer {
  font-size: 1rem !important;
  padding: 0px !important;
  vertical-align: middle !important;
  align-items: center !important;
  border-radius: 0 !important;
  width: max-content;
}
.data-table {
  height: calc(90% - 8.6rem);
  padding-bottom: 10px;
  width: 60%;
}
.features-table {
  height: calc(90% - 8.6rem);
  width: 100%;
}
.features-table .recordPicker {
  position: relative;
  bottom: 3px;
  padding-top: 0.3rem;
}
.alert-dialog {
  display: inline-block;
  width: 45%;
  height: 90%;
  margin-left: auto;
  margin-right: auto;
  min-width: 30%;
}
.alert-dialog .MuiDialog-container .MuiPaper-root {
  min-width: 40%;
}
.autocomplete-div {
  margin-top: 0.3%;
  flex-basis: 35%;
}
.tab-Panel {
  height: 20px !important;
  min-height: 20px !important;
}
.loading-message {
  display: block;
  text-align: center;
  background: white;
  padding: 50px;
  box-shadow: 1px 1px 2px 1px grey;
  border-radius: 3px;
  width: 30%;
  min-width: 30%;
}
.manage-tab-pagination {
  align-items: center;
  margin-top: 1rem;
  height: 8rem;
}
.procos-pagination {
  width: 60%;
  align-items: center;
}
.procos-features-pagination {
  width: 100%;
  align-items: center;
  padding-top: 1%;
}
.common-btn {
  height: 2.5rem;
  white-space: nowrap;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs {
  text-transform: capitalize !important;
  align-items: center;
  justify-content: left !important;
  text-align: left !important;
  min-height: 30px;
  padding: 7px;
  color: rgba(0, 0, 0, 0.87) !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-tabs {
  color: #0d5e87 !important;
  background: #c7e0f4 !important;
  font-weight: 800 !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.pdm-tabs {
  text-transform: capitalize !important;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 7px;
  color: rgba(0, 0, 0, 0.87) !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.pdm-tabs {
  color: #1474a4 !important;
  font-weight: 800 !important;
}
.navigateTabLabel {
  writing-mode: tb-rl;
  height: inherit;
  cursor: pointer;
  font-size: 1.25rem;
  white-space: nowrap;
}
.pinIcon {
  font-size: 1.4rem !important;
}
.tabDrawerMini {
  width: 4.5rem;
  height: auto;
  text-align: center;
  background: #eeeeee;
  z-index: 100;
}
.drawerOpen {
  width: 200px;
}
.drawer-tab {
  min-height: 500px !important;
}
.pdm-tab {
  height: 32px !important;
  min-height: 32px !important;
}
.checkbox-highlight {
  box-shadow: inset 0px 0px 1px 1px orange;
}
.procos-tab-panel {
  min-height: 20px !important;
}
.tabs-padding {
  padding: 7px 15px 7px 15px;
}
.tab-icon {
  margin-right: 5px;
}
.failed-rule {
  max-height: 100px;
  padding: 5px;
}
.autocomplete {
  padding: 3px !important;
}
.contents {
  display: flex;
  justify-content: space-between;
  height: 100%;
}
.leftBar {
  border-right: 1px solid #e0e0e0;
  width: 20%;
  height: 100% !important;
  overflow: hidden;
}
.leftBar .MuiAutocomplete-inputRoot {
  border-radius: 0;
}
.leftBar .defaultExpandIcon {
  color: #0062a1;
}
.leftBar .defaultCollapseIcon {
  color: #0078ce;
}
.leftBar .defaultEndIcon {
  color: #eeeeee;
}
.leftBar .featuresTree {
  height: 80%;
  max-width: 100%;
  overflow-y: auto;
}
.leftBar .treeSearchBar .innerTextField > div {
  padding-top: 0% !important;
  padding-bottom: 0% !important;
}
.leftBar .treeSearchBar .innerTextField > div > div > button {
  visibility: visible !important;
}
.rightBar {
  width: 100% !important;
  height: 95% !important;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 1%;
  padding-left: 0.5%;
}
.properties-div {
  height: 80% !important;
}
.properties-div .refresh-button path {
  font-size: 18px !important;
}
.inputFieldset {
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1.5px;
  border-color: rgba(0, 0, 0, 0.2);
  border-style: solid;
  width: 100%;
  padding-bottom: 4px !important;
  padding-left: 0.8rem !important;
  margin-top: 10px !important;
}
.inputFieldset:hover:not(:focus):not(:focus-within) {
  border-color: rgba(0, 0, 0, 0.87);
}
.inputFieldset:focus-within {
  border-color: #1173a3;
}
.inputFieldset > legend.inputLegend {
  color: rgba(0, 0, 0, 0.6);
  word-break: break-all;
}
.inputFieldset:focus-within > legend.inputLegend {
  color: #1474a4;
}
.inputFieldset:hover:not(:focus):not(:focus-within) > legend.inputLegend {
  color: rgba(0, 0, 0, 0.87);
}
.properties-pane-title {
  padding-bottom: 1px !important;
}
.flow {
  overflow: auto;
  height: 92%;
}
.action-button {
  display: flex;
  height: 8%;
  padding: 1px;
}
.toggle-switch {
  padding-left: 1%;
  padding-top: 0px !important;
}
.switch-field {
  padding: 8px !important;
}
.switch-field .MuiSwitch-track {
  border-radius: 11px;
}
.switch-field .MuiSwitch-track::before,
.switch-field .MuiSwitch-track::after {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
}
.switch-field .MuiSwitch-track::before {
  content: 'Y';
  left: 17px;
  color: white;
}
.switch-field .MuiSwitch-track::after {
  content: 'N';
  right: 8px;
  color: white;
}
.switch-field .MuiSwitch-thumb {
  box-shadow: none;
  width: 16px;
  height: 16px;
  margin: 2px;
}
.warning-icon {
  font-size: 1.8rem !important;
  color: #f7d368;
}
.defaultIcon {
  color: hsl(51, 79%, 25%);
  border: 2px solid hsl(51, 59%, 55%);
  background-color: hsl(51, 89%, 95%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 56px;
}
.defaultIcon.empty {
  border: none;
  background-color: transparent;
}
.MuiDataGrid-columnSeparator--resizable {
  cursor: e-resize !important;
}
.css-15l8jjv .MuiDataGrid-columnSeparator--resizable {
  cursor: e-resize;
  touch-action: none;
}
.status-inactive {
  background: #5a5a5a;
  color: white;
  text-align: center;
}
.status-active {
  background: #2e7d32;
  color: white;
  text-align: center;
}
.inActiveWarningMessage {
  margin-left: 0.5em;
}
.inActiveWarningMessage .warningMessage {
  font-size: 2rem !important;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  color: #f7d368;
  font-size: 1rem !important;
}
.inActiveWarningMessage .warningSize {
  height: 100% !important;
  width: 2em !important;
  color: #f7d368;
}
.inActiveWarningMessage .warningIcon {
  color: #f7d368;
  font-size: 2rem !important;
}
.navbar {
  font-size: 12px !important;
  line-height: 3 !important;
}
.navbar a {
  color: grey;
  text-decoration: none !important;
}
.navbar a.active {
  color: #1474a4;
  border-bottom: 2px solid #1474a4 !important;
  text-decoration: none !important;
}
.headerLogo {
  cursor: pointer !important;
}
.cellWithValueAsNo {
  background-color: pink !important;
  color: #8b0000 !important;
}
.active-menu {
  width: 10rem;
}
.fail-effectivity {
  height: 150px;
  overflow-y: auto;
}
.icon-font-size {
  font-size: 2rem !important;
  margin-right: 5px !important;
}
.properties-content {
  height: 100%;
}
.header-action {
  display: flex;
  justify-content: flex-end;
}
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.enabled {
  pointer-events: auto;
  opacity: 1;
}
.toast-content-default {
  background-color: white;
}
.toast-content-success {
  background-color: #93c47d;
  color: black;
}
.toast-content-warning {
  background-color: #f7d368;
  color: black;
}
.toast-content-error {
  background-color: red;
  color: black;
}
.wi-toast-content-success {
  background-color: #93c47d;
  color: black;
}
.effectivity-toast-content-success {
  margin-top: 90px;
  background-color: #93c47d;
  color: black;
}
.effectivity-toast-content-error {
  margin-top: 90px;
  background-color: red;
  color: black;
}
.absolute-right {
  position: absolute !important;
  right: 0;
}
.appTabs-border {
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
}
.link {
  cursor: pointer;
  text-decoration: underline !important;
  color: blue !important;
}
.data-table-container {
  /* Add this class to the container */
  display: flex;
  flex-direction: column;
  flex: 1;
  /* Allow container to grow */
  overflow: auto;
  /* Allow scrolling if content overflows */
  width: 100%;
}
.data-table-container .data-table {
  flex-grow: 1;
  /* Allow DataTable to grow */
}
.data-table-container .pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  /* Ensure pagination is visible */
  padding: 1rem;
  overflow: auto;
}
.data-table-container .pagination-container .MuiPagination-root {
  width: 100%;
}
.manipulation-dialog {
  width: 100%;
  min-height: 50%;
  height: 70%;
  max-height: 70%;
  max-width: 100%;
  margin-top: 10rem;
  z-index: 99 !important;
}
.manipulation-dialog .formActionButtons {
  text-align: right;
}
.tabsAndActionPanel {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.searchIconForColumn {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.h-3-5 {
  height: 3.5%;
}
.headerLogoButton {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}
.pdmHistoryDialogStyle .paper {
  width: 85% !important;
  height: 110vh !important;
  max-width: 100% !important;
}
.pdmHistoryDialogStyle .title {
  display: flex;
  /* keeps first span at start in normal flow */
  align-items: center;
  /* vertical centering if there's height */
  justify-content: start;
  gap: 4px;
  width: 100%;
  position: relative;
}
.pdmHistoryDialogStyle .start {
  /* stays at the start in normal flow */
  width: max-content;
  min-width: max-content;
  text-align: start;
}
.pdmHistoryDialogStyle .center {
  width: max-content;
  text-align: start;
  display: flex;
  justify-content: start;
  text-overflow: clip;
}
.pdmHistoryDialogStyle .close {
  align-items: center;
  justify-content: center;
  margin-left: auto;
  height: 100%;
  width: max-content;
  min-width: max-content;
  color: white;
}
.pdmHistoryDialogStyle .dialogContent {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px !important;
}
.pdmHistoryDialogStyle .dialogContent .MuiDataGrid-root {
  min-height: 90% !important;
}
.pdmHistoryDialogStyle .dialogContent .manage-tab-pagination {
  margin-top: 0 !important;
  justify-content: center;
  align-items: center;
}
.historyFilterPanel {
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: max-content !important;
}
.historyFilterPanel .historyFilterContent {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
  width: max-content !important;
}
.historyFilterPanel .historyFilterContent .historyFilterRow {
  display: flex;
  gap: 16px;
  flex-direction: row;
  align-items: center;
  width: max-content !important;
}
.historyFilterPanel .historyFilterContent .historyFilterRow .historyFilterFormControl {
  min-width: 145px;
}
.color-red {
  color: red !important;
}
.history-button path {
  font-size: 18px !important;
}
.history-button span {
  font-size: 12px !important;
}
.delete-button {
  text-transform: capitalize !important;
  color: red;
}
.autocomplete-value-mismatch .MuiOutlinedInput-notchedOutline {
  border-color: red !important;
}
.autocomplete-value-mismatch .MuiOutlinedInput-input {
  color: red !important;
  -webkit-text-fill-color: red !important;
}
.autocomplete-value-mismatch .Mui-disabled .MuiOutlinedInput-notchedOutline {
  border-color: red !important;
}
.autocomplete-value-mismatch .Mui-disabled .MuiOutlinedInput-input {
  -webkit-text-fill-color: red !important;
}
.autocomplete-value-mismatch .MuiInputLabel-root.Mui-disabled {
  color: red !important;
}
`, "",{"version":3,"sources":["webpack://./style/index.less","webpack://./style/category.less"],"names":[],"mappings":"AAAA;;;EAGE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AACF;AACE;;;EACE,gBAAA;AAGJ;AACA;EACE,kEAAA;EACA,gBAAA;AACF;AAEA;EACE,kEAAA;AAAF;AAGA;EACE,sBAAA;AADF;AAIA;EACE,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;AAFF;AChCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kCAAA;ADkCF;AC/BA;EACE,kCAAA;EACA,iCAAA;ADiCF;AC9BA;EACE,kCAAA;EACA,iCAAA;ADgCF;AC3BA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AD6BF;AClCA;EAQI,cAAA;AD6BJ;ACrCA;EAYI,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;AD4BJ;AC3CA;EAkBM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AD4BN;ACjDA;EAyBU,0BAAA;AD2BV;ACpDA;EA+BM,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;ADwBN;ACjEA;EA4CQ,UAAA;EACA,aAAA;EACA,mBAAA;ADwBR;ACtEA;EAgDU,WAAA;ADyBV;ACzEA;EAmDU,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;ADyBV;ACnFA;EA8DU,WAAA;ADwBV;ACtFA;EAkEU,mBAAA;ADuBV;ACzFA;EAyEI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,OAAA;EACA,iBAAA;ADmBJ;AClGA;EAkFM,YAAA;EACA,aAAA;EACA,sBAAA;ADmBN;ACvGA;EAuFQ,kBAAA;ADmBR;AC1GA;EA2FQ,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,8BAAA;ADkBR;AClHA;EAqGM,aAAA;EACA,SAAA;EACA,OAAA;ADgBN;ACvHA;EA2GQ,OAAA;EACA,aAAA;EACA,sBAAA;ADeR;AC5HA;EAoHM,aAAA;EACA,mBAAA;EACA,WAAA;ADWN;ACjIA;EAyHQ,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;ADWR;ACTQ;EACE,YAAA;EACA,gBAAA;ADWV;ACRQ;EACE,cAAA;ADUV;ACRU;EACE,WAAA;EACA,qCAAA;ADUZ;ACtJA;EAkJQ,WAAA;EACA,aAAA;ADOR;AC1JA;EAyJI,aAAA;EACA,OAAA;EACA,0BAAA;EACA,kBAAA;ADIJ;AChKA;;;EAkKI,kBAAA;ADGJ;ACrKA;EAsKI,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;ADEJ;AC9KA;EAgLI,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;ADCJ;ACpLA;EAuLI,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;ADAJ;AC1LA;EA8LI,kBAAA;ADDJ;AC7LA;EAkMI,YAAA;EACA,oBAAA;ADFJ;ACjMA;;EAwMI,6BAAA;EACA,gBAAA;EACA,iBAAA;ADHJ;ACQA;EACE,kBAAA;ADNF;ACOE;EAEE,yBAAA;ADNJ;ACSE;EAEE,yBAAA;EAEA,aAAA;ADTJ;ACYE;EAEI,2BAAA;ADXN;ACLA;EAqBI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;ADbJ;ACXA;EA4BI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ADdJ;ACeI;EAEE,uBAAA;ADdN;ACYI;;EAOI,cAAA;EACA,gBAAA;ADfR;ACOI;EAaI,yBAAA;ADjBR;ACII;EAkBI,yBAAA;ADnBR;ACwBI;EAEI,cAAA;EACA,gBAAA;ADvBR;ACoBI;EAQI,yBAAA;ADzBR;ACiBI;EAYI,yBAAA;AD1BR;AC3CA;EA2EI,aAAA;EACA,mBAAA;EACA,OAAA;AD7BJ;AChDA;EAgFI,aAAA;EACA,mBAAA;EACA,OAAA;AD7BJ;ACrDA;EAqFI,gBAAA;AD7BJ;ACxDA;EAwFI,aAAA;EACA,mBAAA;EACA,gBAAA;AD7BJ;AC7DA;EA6FI,iBAAA;AD7BJ;ACkCA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;ADhCF;AC2BA;EAQI,kBAAA;ADhCJ;ACkCI;EACE,cAAA;ADhCN;ACqBA;EAgBI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,gBAAA;EACA,UAAA;ADlCJ;ACWA;EA0BM,OAAA;EACA,gBAAA;ADlCN;ACqCI;;EAEE,oCAAA;EACA,8BAAA;EACA,uBAAA;EACA,UAAA;EACA,6CAAA;ADnCN;ACsCI;;EAEE,oCAAA;EACA,8BAAA;EACA,uBAAA;EACA,UAAA;EACA,4CAAA;ADpCN;ACTA;EAiDM,WAAA;EACA,kBAAA;ADrCN;AC4CE;EACE,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,oBAAA;AD1CJ;AC4CE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AD1CJ;ACoCE;EASI,OAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AD1CN;AC0BE;EAmBM,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AD1CR;ACoBE;EA0BM,cAAA;EACA,mBAAA;EACA,WAAA;AD3CR;ACeE;EAiCI,aAAA;EACA,mBAAA;EACA,QAAA;AD7CN;ACUE;EAsCM,WAAA;EACA,eAAA;AD7CR;ACkDE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;ADhDJ;AC4CE;EAMI,gBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AD/CN;ACiCE;EAiBM,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AD/CR;AC2BE;EAwBM,cAAA;EACA,mBAAA;EACA,WAAA;ADhDR;ACqDE;EACE,YAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;ADnDJ;ACqDI;EACE,mBAAA;ADnDN;ACsDI;EACE,mBAAA;ADpDN;ACwDE;EACE,YAAA;EACA,eAAA;EACA,oBAAA;ADtDJ;ACmDE;EAMI,6BAAA;ADtDN;AC4DA;EAGM,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AD5DN;ACqDA;EAWM,WAAA;AD7DN;ACiEA;EAEI,UAAA;ADhEJ;ACoEA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;ADlEF;ACoDA;EAiBI,YAAA;EACA,eAAA;ADlEJ;ACuEA;EACE,wBAAA;ADrEF;ACwEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;ADtEF;ACkEA;EAOI,gBAAA;ADtEJ;AC+DA;EAWI,WAAA;ADvEJ;AC2EA;EACE,gBAAA;EACA,aAAA;ADzEF;AC4EA;EACE,eAAA;AD1EF;ACyEA;EAII,yCAAA;AD1EJ;AC8EA;EACE,iBAAA;EACA,yCAAA;EACA,oCAAA;EACA,4BAAA;AD5EF;AC+EA;EACE,0BAAA;EACA,yBAAA;AD7EF;ACgFA;EACE,oBAAA;EACA,6BAAA;AD9EF;ACiFA;EACE,oCAAA;AD/EF;ACkFA;EACE,sBAAA;EACA,wBAAA;ADhFF;ACoFA;EACE,4BAAA;EACA,cAAA;ADlFF;ACqFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;ADnFF;ACsFA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;ADpFF;ACuFA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;ADrFF;ACwFA;EACE,mCAAA;EACA,mBAAA;ADtFF;ACyFA;EACE,mCAAA;ADvFF;AC0FA;EACE,eAAA;ADxFF;AC2FA;EACE,mDAAA;ADzFF;AC4FA;EACE,mBAAA;AD1FF;AAnfA;EAEI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAofJ;AA/eA;EACE,UAAA;EACA,WAAA;AAifF;AA9eA;EACE,mBAAA;AAgfF;AA7eA;EACE,mBAAA;AA+eF;AA5eA;EACE,mBAAA;AA8eF;AA3eA;EAkBE,4CAAA;EACA,YAAA;EACA,iBAAA;EA8BA,aAAA;EAoBA,mBAAA;AA4aF;AAjfE;EAiDA,aAAA;EAiDA,sBAAA;EA/FE,eAAA;AAmfJ;AAvfA;EAQI,iBAAA;EACA,kBAAA;AAkfJ;AA3fA;EAkDE,aAAA;EAoBA,mBAAA;EAvDE,iBAAA;AAifJ;AAveE;EACE,yBAAA;AAyeJ;AAteE;EACE,yBAAA;AAweJ;AAreE;EACE,yBAAA;AAueJ;AApeE;EACE,yBAAA;AAseJ;AAleA;EAEI,UAAA;EACA,YAAA;AAmeJ;AA/dA;EACE,aAAA;AAieF;AA9dA;EACE,oBAAA;AAgeF;AA7dA;EACE,cAAA;AA+dF;AA5dA;EACE,qBAAA;AA8dF;AA3dA;EACE,eAAA;AA6dF;AA1dA;EACE,mBAAA;AA4dF;AAzdA;EACE,sBAAA;AA2dF;AAxdA;EACE,iBAAA;AA0dF;AAvdA;EACE,WAAA;EACA,YAAA;AAydF;AAtdA;EACE,SAAA;AAwdF;AArdA;EACE,UAAA;AAudF;AApdA;EACE,UAAA;AAsdF;AAndA;EACE,sBAAA;AAqdF;AAldA;EACE,WAAA;AAodF;AAjdA;EACE,aAAA;AAmdF;AAhdA;EACE,UAAA;AAkdF;AA/cA;EACE,UAAA;AAidF;AA9cA;EACE,UAAA;AAgdF;AA7cA;EACE,UAAA;AA+cF;AA5cA;EACE,UAAA;AA8cF;AA3cA;EACE,aAAA;AA6cF;AA1cA;EACE,cAAA;AA4cF;AAzcA;EACE,cAAA;AA2cF;AAxcA;EACE,eAAA;AA0cF;AAvcA;EACE,cAAA;AAycF;AAtcA;EACE,UAAA;AAwcF;AArcA;EACE,WAAA;AAucF;AApcA;EACE,WAAA;AAscF;AAncA;EACE,uBAAA;AAqcF;AAlcA;EACE,uBAAA;AAocF;AAjcA;EACE,YAAA;AAmcF;AAhcA;EACE,eAAA;AAkcF;AA/bA;EACE,SAAA;AAicF;AA9bA;EACE,aAAA;AAgcF;AA7bA;EACE,0BAAA;AA+bF;AA5bA;EACE,eAAA;AA8bF;AA3bA;EACE,4BAAA;AA6bF;AA1bA;EACE,gBAAA;AA4bF;AAzbA;EACE,+BAAA;AA2bF;AAxbA;EACE,cAAA;AA0bF;AAvbA;EACE,0BAAA;AAybF;AAtbA;EACE,iBAAA;EACA,kBAAA;AAwbF;AArbA;EACE,uBAAA;AAubF;AApbA;EACE,uBAAA;AAsbF;AAnbA;EACE,uBAAA;AAqbF;AAlbA;EACE,YAAA;AAobF;AAjbA;EACE,wBAAA;AAmbF;AAhbA;EACE,aAAA;AAkbF;AA/aA;EACE,aAAA;AAibF;AA9aA;EACE,aAAA;AAgbF;AA7aA;EACE,yBAAA;AA+aF;AA5aA;EACE,2BAAA;AA8aF;AA3aA;EACE,6BAAA;AA6aF;AA1aA;EACE,eAAA;AA4aF;AAzaA;EACE,gBAAA;AA2aF;AAxaA;EACE,4BAAA;AA0aF;AAvaA;EACE,8BAAA;AAyaF;AAtaA;EACE,YAAA;AAwaF;AAraA;EA/BE,yBAAA;EAoBA,4BAAA;AAobF;AApaA;EApBE,gBAAA;EAJA,eAAA;AAgcF;AAnaA;EACE,cAAA;AAqaF;AAlaA;EACE,gBAAA;AAoaF;AAjaA;EACE,gBAAA;AAmaF;AAhaA;EACE,2BAAA;AAkaF;AA/ZA;EACE,4BAAA;AAiaF;AA9ZA;EACE,kBAAA;AAgaF;AA7ZA;EACE,qCAAA;AA+ZF;AA5ZA;EACE,iBAAA;AA8ZF;AA3ZA;EACE,8BAAA;AA6ZF;AA1ZA;EACE,sBAAA;AA4ZF;AAzZA;EACE,uBAAA;AA2ZF;AAxZA;EACE,mBAAA;AA0ZF;AAvZA;EACE,kBAAA;AAyZF;AAtZA;EACE,sBAAA;AAwZF;AArZA;EACE,gCAAA;AAuZF;AApZA;EACE,uBAAA;AAsZF;AAnZA;EACE,sBAAA;AAqZF;AAlZA;EACE,yBAAA;AAoZF;AAjZA;EACE,8BAAA;AAmZF;AAhZA;EACE,2BAAA;AAkZF;AA/YA;EACE,YAAA;AAiZF;AA9YA;EACE,yBAAA;AAgZF;AA7YA;EACE,oBAAA;AA+YF;AA5YA;EA/UE,aAAA;EAoBA,mBAAA;AA2sBF;AA3YA;EApVE,aAAA;EAwBA,sBAAA;AA2sBF;AA1YA;EACE,2BAAA;EACA,uBAAA;AA4YF;AAzYA;EACE,eAAA;AA2YF;AAxYA;EACE,0BAAA;AA0YF;AAvYA;EACE,kBAAA;AAyYF;AAtYA;EACE,gBAAA;AAwYF;AArYA;EACE,UAAA;EACA,qBAAA;AAuYF;AApYA;EACE,kBAAA;AAsYF;AAnYA;EACE,uBAAA;AAqYF;AAlYA;EACE,uBAAA;AAoYF;AAjYA;EACE,YAAA;AAmYF;AAhYA;EACE,aAAA;AAkYF;AAhYA;EACE,2BAAA;AAkYF;AA/XA;EACE,yBAAA;AAiYF;AA9XA;EACE,2BAAA;AAgYF;AA7XA;EACE,SAAA;AA+XF;AA5XA;EACE,yBAAA;AA8XF;AA3XA;EACE,UAAA;AA6XF;AA1XA;EACE,SAAA;AA4XF;AA/WE;EA5aA,aAAA;EAwBA,sBAAA;EAkUA,2BAAA;EACA,uBAAA;EA3TA,WAAA;EACA,YAAA;EA+YE,UAAA;AAoXJ;AAzXA;EA3aE,aAAA;EAoBA,mBAAA;EAwSA,8BAAA;EA5BA,mBAAA;EAuIA,WAAA;EACA,YAAA;AAoYF;AAjYA;EAjPE,wBAAA;EA1LA,aAAA;EAwbI,cAAA;EACA,iBAAA;EACA,eAAA;AAyXN;AAxYA;EA3aE,aAAA;EAoBA,mBAAA;EAwSA,8BAAA;EA5BA,mBAAA;EAuIA,WAAA;EACA,YAAA;AAmZF;AAhZA;EAvZE,mBAAA;EAwSA,8BAAA;EA5RA,WAAA;EACA,YAAA;EAqaE,gBAAA;EACA,6BAAA;AA4XJ;AAxZA;EAgCI,WAAA;AA2XJ;AAvXA;EA/cE,aAAA;EAoBA,mBAAA;EA8bA,iBAAA;AAyXF;AA5XA;EAhHE,eAAA;EAuHE,0BAAA;EACA,WAAA;AAyXJ;AApXE;EA5dA,aAAA;EAoBA,mBAAA;EAsUA,2BAAA;EACA,uBAAA;AA2fF;AA3XA;EA3dE,aAAA;EAoBA,mBAAA;EA+cE,8BAAA;EACA,mBAAA;EApcF,WAAA;EACA,YAAA;EAqcE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,iCAAA;AAyXJ;AAvYA;EA3dE,aAAA;EAoBA,mBAAA;EA0dE,2BAAA;EACA,mBAAA;AAyXJ;AA7YA;EAwBI,SAAA;AAwXJ;AAhZA;EA5HE,eAAA;EAyJE,cAAA;AAuXJ;AAnXA;EA7JE,eAAA;EA+JA,uBAAA;EAxUA,uBAAA;AA8rBF;AAxXA;EAMI,YAAA;EACA,WAAA;AAqXJ;AAhXE;EACE,UAAA;EACA,WAAA;AAkXJ;AA/WE;EACE,WAAA;EACA,YAAA;EAvgBF,cAAA;EA6BA,SAAA;EA6eE,mBAAA;EACA,yBAAA;EACA,6CAAA;EACA,mBAAA;AAiXJ;AA7WA;EArSE,cAAA;EAuSA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AA+WF;AAvXA;EAWI,eAAA;EACA,oBAAA;AA+WJ;AA3WA;EACE,uBAAA;EACA,2BAAA;AA6WF;AA1WA;EAnKE,yBAAA;EAsKE,iBAAA;EACA,eAAA;EACA,+CAAA;EACA,YAAA;EACA,2BAAA;AA2WJ;AAlXA;EAWI,YAAA;AA0WJ;AArXA;EAeI,2BAAA;AAyWJ;AAxXA;EAvME,kBAAA;EA2NE,UAAA;EACA,QAAA;EACA,YAAA;AAwWJ;AApWA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAsWF;AAnWA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAqWF;AAlWA;EACE,YAAA;EACA,aAAA;EACA,YAAA;AAoWF;AAjWA;EA3lBE,aAAA;EA6lBA,wBAAA;AAmWF;AAhWA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAkWF;AA/VA;EACE,eAAA;EACA,YAAA;AAiWF;AA9VA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAgWF;AA7VA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;AA+VF;AA5VA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AA8VF;AA3VA;EACE,oCAAA;AA6VF;AA1VA;EACE,cAAA;EACA,iBAAA;AA4VF;AAzVA;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AA2VF;AAhWA;EAQI,aAAA;EACA,mBAAA;EACA,2BAAA;AA2VJ;AAvVA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAyVF;AAtVA;EACE,2BAAA;AAwVF;AArVA;EACE,YAAA;AAuVF;AApVA;EACE,2BAAA;EACA,YAAA;AAsVF;AAnVA;EACE,YAAA;EACA,kBAAA;AAqVF;AAlVA;EACE,yBAAA;AAoVF;AAjVA;EACE,kCAAA;EACA,iCAAA;EACA,gBAAA;EACA,6BAAA;AAmVF;AAhVA;EACE,4BAAA;EACA,+BAAA;AAkVF;AAhVA;EACE,4BAAA;EACA,+BAAA;AAkVF;AAhVA;EACE,kBAAA;EACA,sBAAA;AAkVF;AA/UA;EACE,sBAAA;AAiVF;AA/UA;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AAiVF;AArVA;EAOI,aAAA;EACA,iBAAA;AAiVJ;AA7UA;EACE,aAAA;EACA,yBAAA;AA+UF;AA5UA;EACE,yBAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;AA8UF;AA3UA;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;AA6UF;AA1UA;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;AA4UF;AAzUA;EACE,qBAAA;AA2UF;AAvUE;EAnvBA,aAAA;EAoBA,mBAAA;EA4SA,2BAAA;EAhCA,mBAAA;EAwdE,WAAA;EACA,aAAA;AAyUJ;AAhVA;EA3VE,yBAAA;EAuWE,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AAwUJ;AA3VA;EAuBI,iBAAA;AAuUJ;AAnUA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AAqUF;AA1UA;EAQI,2BAAA;EACA,8BAAA;EACA,kBAAA;AAqUJ;AA/UA;EAeI,8BAAA;AAmUJ;AAlVA;EAoBI,6BAAA;EACA,qBAAA;EACA,sBAAA;AAiUJ;AA7TA;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AA+TF;AArUA;EASI,gBAAA;EACA,2BAAA;AA+TJ;AAzUA;EAcI,UAAA;EACA,SAAA;AA8TJ;AA7UA;EAmBI,0BAAA;EACA,aAAA;EA3zBF,aAAA;EAoBA,mBAAA;EA4RA,uBAAA;EAhBA,mBAAA;AA41BF;AArVA;EAvyBE,aAAA;EAwBA,sBAAA;EAwQA,mBAAA;EAqiBI,YAAA;EACA,8BAAA;AA6TN;AA5VA;EAkCQ,YAAA;EACA,WAAA;AA6TR;AAhWA;EAvyBE,aAAA;EAwBA,sBAAA;AAmnCF;AAtTA;EACE,yBAAA;EA3cA,oCAAA;AAowBF;AArTA;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,8BAAA;EACA,2BAAA;EACA,kBAAA;AAuTF;AApTA;EACE,0BAAA;EACA,oBAAA;EACA,UAAA;AAsTF;AAnTA;EACE,0BAAA;EACA,WAAA;AAqTF;AAvTA;EAKI,kBAAA;EACA,WAAA;EACA,mBAAA;AAqTJ;AAjTA;EAKE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AA+SF;AAzTA;EAEI,cAAA;AA0TJ;AA/SA;EACE,gBAAA;EACA,eAAA;AAiTF;AA9SA;EACE,uBAAA;EACA,2BAAA;AAgTF;AA7SA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AA+SF;AA5SA;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;AA8SF;AA3SA;EACE,UAAA;EACA,mBAAA;AA6SF;AA1SA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;AA4SF;AAzSA;EACE,cAAA;EACA,mBAAA;AA2SF;AAxSA;EAhqBE,qCAAA;EAoBA,mBAAA;EAYA,gCAAA;EA5CA,2BAAA;EAirBA,gBAAA;EACA,YAAA;EACA,qCAAA;AA0SF;AAvSA;EACE,yBAAA;EACA,8BAAA;EACA,2BAAA;AAySF;AAtSA;EAhrBE,qCAAA;EAoBA,mBAAA;EAgBA,uBAAA;EAgpBA,gBAAA;EACA,YAAA;EACA,qCAAA;AAwSF;AArSA;EACE,yBAAA;EACA,2BAAA;AAuSF;AApSA;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EAEA,kBAAA;EACA,mBAAA;AAqSF;AAlSA;EACE,4BAAA;AAoSF;AAjSA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAmSF;AAhSA;EACE,YAAA;AAkSF;AA/RA;EACE,4BAAA;AAiSF;AA9RA;EACE,uBAAA;EACA,2BAAA;AAgSF;AA7RA;EACE,wCAAA;AA+RF;AA5RA;EACE,2BAAA;AA8RF;AA3RA;EACE,0BAAA;AA6RF;AA1RA;EACE,iBAAA;AA4RF;AAzRA;EACE,iBAAA;EAv0BA,YAAA;AAmmCF;AAxRA;EACE,uBAAA;AA0RF;AAvRA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAyRF;AAtRA;EACE,+BAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;AAwRF;AA5RA;EAOI,gBAAA;AAwRJ;AA/RA;EAWI,cAAA;AAuRJ;AAlSA;EAeI,cAAA;AAsRJ;AArSA;EAmBI,cAAA;AAqRJ;AAxSA;EAuBI,WAAA;EACA,eAAA;EACA,gBAAA;AAoRJ;AA7SA;EA+BM,0BAAA;EACA,6BAAA;AAiRN;AAjTA;EAqCM,8BAAA;AA+QN;AA1QA;EACE,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AA4QF;AAzQA;EACE,sBAAA;AA2QF;AA5QA;EAIM,0BAAA;AA2QN;AAtQA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AAwQF;AAtQE;EACE,iCAAA;AAwQJ;AArQE;EACE,qBAAA;AAuQJ;AApQE;EACE,yBAAA;EACA,qBAAA;AAsQJ;AAnQE;EACE,cAAA;AAqQJ;AAlQE;EACE,0BAAA;AAoQJ;AAhQA;EACE,8BAAA;AAkQF;AA/PA;EACE,cAAA;EACA,WAAA;AAiQF;AA9PA;EACE,aAAA;EACA,UAAA;EACA,YAAA;AAgQF;AA7PA;EACE,gBAAA;EACA,2BAAA;AA+PF;AA5PA;EACE,uBAAA;AA8PF;AA7PE;EACE,mBAAA;AA+PJ;AA9PI;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AAgQN;AA9PI;EACE,YAAA;EACA,UAAA;EACA,YAAA;AAgQN;AA9PI;EACE,YAAA;EACA,UAAA;EACA,YAAA;AAgQN;AA7PE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA+PJ;AA3PA;EACE,4BAAA;EACA,cAAA;AA6PF;AA1PA;EACE,wBAAA;EACA,mCAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA4PF;AA3PE;EACE,YAAA;EACA,6BAAA;AA6PJ;AAzPA;EACE,2BAAA;AA2PF;AAxPA;EACE,gBAAA;EACA,kBAAA;AA0PF;AAvPA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;AAyPF;AAtPA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;AAwPF;AArPA;EACE,kBAAA;AAuPF;AAxPA;EAgBI,0BAAA;EAvtCF,aAAA;EAwBA,sBAAA;EAorCE,gBAAA;EACA,cAAA;EACA,0BAAA;AAyPJ;AAhQA;EAUI,uBAAA;EACA,qBAAA;EACA,cAAA;AAyPJ;AArQA;EAeI,cAAA;EACA,0BAAA;AAyPJ;AArPA;EACE,0BAAA;EACA,yBAAA;AAuPF;AArPA;EACE,WAAA;EACA,gCAAA;AAuPF;AArPA;EACE,cAAA;EACA,2CAAA;EACA,gCAAA;AAuPF;AApPA;EACE,0BAAA;AAsPF;AAnPA;EACE,iCAAA;EACA,yBAAA;AAqPF;AAlPA;EACE,YAAA;AAoPF;AAjPA;EACE,aAAA;EACA,gBAAA;AAmPF;AAhPA;EACE,0BAAA;EACA,4BAAA;AAkPF;AA/OA;EACE,YAAA;AAiPF;AA9OA;EACE,aAAA;EACA,yBAAA;AAgPF;AA9OA;EACE,oBAAA;EACA,YAAA;AAgPF;AA9OA;EACE,oBAAA;EACA,UAAA;AAgPF;AA7OA;EACE,uBAAA;AA+OF;AA5OA;EACE,yBAAA;EACA,YAAA;AA8OF;AA3OA;EACE,yBAAA;EACA,YAAA;AA6OF;AA1OA;EACE,qBAAA;EACA,YAAA;AA4OF;AAzOA;EACE,yBAAA;EACA,YAAA;AA2OF;AAxOA;EACE,gBAAA;EACA,yBAAA;EACA,YAAA;AA0OF;AAvOA;EACE,gBAAA;EACA,qBAAA;EACA,YAAA;AAyOF;AAtOA;EACE,6BAAA;EACA,QAAA;AAwOF;AArOA;EACE,4CAAA;AAuOF;AApOA;EA/9BE,eAAA;EAi+BA,qCAAA;EACA,sBAAA;AAsOF;AAnOA;EAqOE,oCAAoC;EAnOpC,aAAA;EACA,sBAAA;EACA,OAAA;EAqOA,4BAA4B;EApO5B,cAAA;EAsOA,yCAAyC;EArOzC,WAAA;AAuOF;AApOA;EACE,YAAA;EAsOA,4BAA4B;AAC9B;AApOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EAsOA,iCAAiC;EArOjC,aAAA;EACA,cAAA;AAuOF;AApOA;EACE,WAAA;AAsOF;AAnOA;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAqOF;AAlOA;EACE,iBAAA;AAoOF;AAjOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAmOF;AAhOA;EAl3CE,aAAA;EAoBA,mBAAA;EA4QA,mBAAA;AAuzCF;AAhOA;EACE,YAAA;AAkOF;AA/NA;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAiOF;AA9NA;EAEI,qBAAA;EACA,wBAAA;EACA,0BAAA;AA+NJ;AAnOA;EAQI,aAAA;EA8NF,6CAA6C;EA7N3C,mBAAA;EA+NF,yCAAyC;EA9NvC,sBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AAgOJ;AA7OA;EA+OE,sCAAsC;EA7NpC,kBAAA;EACA,sBAAA;EACA,iBAAA;AA+NJ;AAnPA;EAwBI,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA8NJ;AA1PA;EAgCI,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AA6NJ;AAnQA;EAyCI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wBAAA;AA6NJ;AAzQA;EA8CM,0BAAA;AA8NN;AA5QA;EAiDM,wBAAA;EACA,uBAAA;EACA,mBAAA;AA8NN;AAzNA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AA2NF;AA/NA;EAMI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;AA4NJ;AAvOA;EAaM,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;AA6NN;AA9OA;EAmBQ,gBAAA;AA8NR;AAxNA;EACE,qBAAA;AA0NF;AAvNA;EAEI,0BAAA;AAwNJ;AA1NA;EAKI,0BAAA;AAwNJ;AApNA;EAptCE,qCAAA;EAstCA,UAAA;AAsNF;AAnNA;EAEI,4BAAA;AAoNJ;AAtNA;EAMI,qBAAA;EACA,uCAAA;AAmNJ;AA1NA;EAYM,4BAAA;AAiNN;AA7NA;EAgBM,uCAAA;AAgNN;AAhOA;EAqBI,qBAAA;AA8MJ","sourcesContent":["html,\nbody,\n#root {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font-size: small;\n\n  &#root {\n    overflow: hidden;\n  }\n}\n\nbody {\n  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;\n  overflow: hidden;\n}\n\nbody * {\n  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: 'NeueFrutigerWorldW02-Regular';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url('../public/NeueFrutigerWorldW02-Regular.woff2');\n}\n\n@import url(./category.less);\n\n@philips-blue: #1474a4;\n@philips-gray: #eeeeee;\n@philips-green: #93c47d;\n@philips-orange: #f7d368;\n@philips-yellow: #f3f66b;\n@philips-red: red;\n\n@dialogActionDivider: rgba(0, 0, 0, 0.12);\n\n// Badge styling for filter/column counters\n.small-badge {\n  .MuiBadge-badge {\n    font-size: 0.65rem;\n    height: 16px;\n    min-width: 16px;\n    padding: 0 4px;\n  }\n}\n\n//Scroll bar Stylings\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #5a9dbf;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #5a9dbf;\n}\n\n.footer {\n  &.root {\n    .d-flex();\n    .w-100();\n    font-size: 12px;\n  }\n\n  .env {\n    margin-right: 1px;\n    padding-right: 1px;\n  }\n\n  .termsAndCondition {\n    .d-flex();\n    .flex-row();\n    margin-right: 1px;\n  }\n\n  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);\n  color: black;\n  margin-right: 1px;\n\n  .d-flex();\n  .flex-row();\n\n  &.bg-gray {\n    background-color: @philips-gray;\n  }\n\n  &.bg-green {\n    background-color: @philips-green;\n  }\n\n  &.bg-orange {\n    background-color: @philips-orange;\n  }\n\n  &.bg-yellow {\n    background-color: @philips-yellow;\n  }\n}\n\n.termsAndCondition-dialog {\n  .paperClass {\n    width: 45%;\n    height: 60vh;\n  }\n}\n\n.d-flex {\n  display: flex;\n}\n\n.d-inline-flex {\n  display: inline-flex;\n}\n\n.d-block {\n  display: block;\n}\n\n.d-inline-block {\n  display: inline-block;\n}\n\n.d-inline {\n  display: inline;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap;\n}\n\n.squareSize {\n  width: 100%;\n  height: 100%;\n}\n\n.w-0 {\n  width: 0%;\n}\n\n.w-25 {\n  width: 25%;\n}\n\n.w-50 {\n  width: 50%;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-25ch {\n  width: '25ch';\n}\n\n.w-10 {\n  width: 10%;\n}\n\n.w-20 {\n  width: 20%;\n}\n\n.w-40 {\n  width: 40%;\n}\n\n.w-45 {\n  width: 45%;\n}\n\n.w-90 {\n  width: 90%;\n}\n\n.mw-0 {\n  max-width: 0%;\n}\n\n.mw-25 {\n  max-width: 25%;\n}\n\n.mw-50 {\n  max-width: 50%;\n}\n\n.mw-100 {\n  max-width: 100%;\n}\n\n.mw-10 {\n  max-width: 10%;\n}\n\n.h-0 {\n  height: 0%;\n}\n\n.h-25 {\n  height: 25%;\n}\n\n.h-50 {\n  height: 50%;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-90vh {\n  height: 90vh !important;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-inherit {\n  height: inherit;\n}\n\n.m-0 {\n  margin: 0;\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n\n.mt-1em {\n  margin-top: 1em !important;\n}\n\n.mr-0 {\n  margin-right: 0;\n}\n\n.mr-5px {\n  margin-right: 5px !important;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.mb-05em {\n  margin-bottom: 0.5em !important;\n}\n\n.ml-0 {\n  margin-left: 0;\n}\n\n.ml-1 {\n  margin-left: 1% !important;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.p-1 {\n  padding: 1px !important;\n}\n\n.p-3px {\n  padding: 3px !important;\n}\n\n.p-5px {\n  padding: 5px;\n}\n\n.p-10px {\n  padding: 10px !important;\n}\n\n.p-20px {\n  padding: 20px;\n}\n\n.p-15px {\n  padding: 15px;\n}\n\n.p-1rem {\n  padding: 1rem;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 1em !important;\n}\n\n.pr-1 {\n  padding-right: 1em !important;\n}\n\n.pl-0 {\n  padding-left: 0;\n}\n\n.pr-0 {\n  padding-right: 0;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 1em !important;\n}\n\n.float-right {\n  float: right;\n}\n\n.py-0 {\n  .pt-0();\n  .pb-0();\n}\n\n.px-0 {\n  .pr-0();\n  .pl-0();\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflowX-auto {\n  overflow-x: auto;\n}\n\n.overflowY-auto {\n  overflow-y: auto;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n\n.ws-nowrap {\n  white-space: nowrap !important;\n}\n\n.vertical-middle {\n  vertical-align: middle;\n}\n\n.align-top {\n  align-items: flex-start;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.alignself-center {\n  align-self: center;\n}\n\n.alignself-start {\n  align-self: self-start;\n}\n\n.justify-left {\n  justify-content: left !important;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-right {\n  justify-content: right;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.justify-spacebetween {\n  justify-content: space-between;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\n.warning {\n  color: @philips-orange !important;\n}\n\n.bottomUnset {\n  border-bottom: unset;\n}\n\n.rowFlex {\n  .d-flex();\n  .flex-row();\n}\n\n.colFlex {\n  .d-flex();\n  .flex-column();\n}\n\n.flex-start {\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default !important;\n}\n\n.position-absolute {\n  position: absolute;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.textWidth50 {\n  width: 50%;\n  display: inline-block;\n}\n\n.overflowY-hidden {\n  overflow-y: hidden;\n}\n\n.overflow-ellipsis {\n  text-overflow: ellipsis;\n}\n\n.overflowWrap-anywhere {\n  overflow-wrap: anywhere;\n}\n\n.zindex-100 {\n  z-index: 100;\n}\n\n.zindex-2000 {\n  z-index: 2000;\n}\n.border-radius-0 {\n  border-radius: 0 !important;\n}\n\n.bg-philips-blue {\n  background-color: @philips-blue;\n}\n\n.bg-lightgray {\n  background-color: lightgray;\n}\n\n.b-0 {\n  border: 0;\n}\n\n.philipsBlue {\n  color: @philips-blue !important;\n}\n\n.PhilipsRed {\n  color: @philips-red;\n}\n\n.zoom80 {\n  zoom: 80%;\n}\n\n.secondaryHeader(@h: 38px) {\n  .d-flex();\n  .flex-row();\n  .justify-spacebetween();\n  .align-center();\n  width: 100%;\n  height: @h;\n}\n\n.appRouter {\n  &.root {\n    .colFlex();\n    .flex-start();\n    .squareSize();\n    padding: 0;\n  }\n\n  .secondaryHeader {\n    .secondaryHeader(38px);\n    .headername {\n      .p-10px();\n      .d-flex();\n      color: @philips-blue;\n      font-weight: bold;\n      font-size: 14px;\n    }\n  }\n\n  .secondaryHeaderTabs {\n    .secondaryHeader(auto);\n  }\n\n  .appRouterContent {\n    .flex-row();\n    .justify-spacebetween();\n    .squareSize();\n    overflow: hidden;\n    width: -webkit-fill-available;\n  }\n\n  .divider {\n    width: 100%;\n  }\n}\n\n.termsAndConditionStyle {\n  .d-flex();\n  .flex-row();\n  margin-right: 1px;\n\n  .title {\n    .cursor-pointer();\n    text-decoration: underline;\n    color: blue;\n  }\n}\n\n.headerStyle {\n  &.root {\n    .rowFlex();\n    .flex-start();\n  }\n\n  .toolbar {\n    .rowFlex();\n    justify-content: space-between;\n    align-items: center;\n    .squareSize();\n    padding: 0 10px;\n    min-height: 3rem;\n    padding-top: 0.3rem !important;\n    padding-bottom: 0.3rem !important;\n  }\n\n  .toolbarSection {\n    .rowFlex();\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .tooltip {\n    margin: 2;\n  }\n\n  .button-icon {\n    .cursor-pointer();\n    color: #ffffff;\n  }\n}\n\n.userPanelIconButton {\n  .cursor-pointer();\n  color: white !important;\n  .p-5px() !important;\n\n  .userProfileIcon {\n    height: 2rem;\n    width: 2rem;\n  }\n}\n\n.popperStyle {\n  &.arrow {\n    width: 3em;\n    height: 3em;\n  }\n\n  &::before {\n    content: '';\n    margin: auto;\n    .d-block();\n    .w-0();\n    border-style: solid;\n    border-width: 0px 1em 1em;\n    border-color: transparent transparent rgb(255, 255, 255);\n    margin-top: -0.4rem;\n  }\n}\n\n.middle-container {\n  .overflow-auto();\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100% !important;\n  padding: 0.5em 1em;\n\n  .mainHeader {\n    margin-top: 0em;\n    margin-bottom: 0.2em;\n  }\n}\n\n.common-dialog-paper {\n  width: 550px !important;\n  min-width: 550px !important;\n}\n\n.common-dialog-style {\n  .header {\n    .bg-philips-blue();\n    font-size: 1.2rem;\n    padding: 0.5rem;\n    border-bottom: 0.1rem solid @dialogActionDivider;\n    color: white;\n    text-align: left !important;\n  }\n\n  .paper {\n    height: 60vh;\n  }\n\n  .dialogContent {\n    padding-top: 4vh !important;\n  }\n\n  .closeIcon {\n    .position-absolute();\n    right: 0px;\n    top: 0px;\n    color: white;\n  }\n}\n\n.landing-Page-body {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.header4 {\n  font-size: large;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n}\n\n.catalog-Container {\n  width: 376px;\n  height: 100px;\n  padding: 5px;\n}\n\n.catalog-cardLayout {\n  .d-flex();\n  padding: 10px !important;\n}\n\n.catalog-image {\n  height: 80px;\n  width: 80px;\n  margin-left: 5px;\n  margin-top: 5px;\n}\n\n.catalog-info {\n  flex-basis: 90%;\n  padding: 5px;\n}\n\n.catalog-productDescription {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 34ch;\n}\n\n.noData-label {\n  width: 50%;\n  margin-left: 45%;\n  padding-top: 15%;\n}\n\n.catalog-icon {\n  display: flex;\n  flex-basis: 10%;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.catalog-create {\n  background-color: @philips-blue !important;\n}\n\n.productCatalogCardHeader {\n  color: rgb(20, 116, 164);\n  font-weight: bold;\n}\n\n.list-Section {\n  display: block;\n  height: calc(90% - 8.6rem);\n  padding: 0px 10px 10px 10px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  ul > div {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n}\n\n.list-Section-Tab {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.list-Items {\n  padding-top: 0px !important;\n}\n\n.list-Section::-webkit-scrollbar {\n  height: 10px;\n}\n\n.list-ItemsContainer {\n  margin-left: 0px !important;\n  padding: 5px;\n}\n\n.recordsPerPage {\n  height: 30px;\n  margin-right: 15px;\n}\n\n.recordsPerPage > div {\n  padding: 8.5px !important;\n}\n\n.refresh-button {\n  min-height: min-content !important;\n  min-width: min-content !important;\n  padding: 6px 8px;\n  position: relative !important;\n}\n\n.procos-export-button {\n  margin-left: 30px !important;\n  text-transform: none !important;\n}\n.pcs-export-button {\n  margin-left: 40px !important;\n  text-transform: none !important;\n}\n.refresh-button > span {\n  padding-right: 2px;\n  margin: 0px !important;\n}\n\n.export-button > span {\n  margin: 4px !important;\n}\n.recordsChange-conatiner {\n  display: flex;\n  flex-direction: row-reverse;\n  margin-right: 10px;\n  align-items: center;\n\n  .form-control {\n    width: 5.5rem;\n    margin-left: 10px;\n  }\n}\n\n.Records {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.home-icon {\n  color: @philips-blue !important;\n  width: 100%;\n  padding: 3px !important;\n  margin: 0px !important;\n}\n\n.action-icon {\n  color: @philips-blue !important;\n  margin: 0px !important;\n  padding: 2px !important;\n}\n\n.action-icon-disabled {\n  color: @philips-gray !important;\n  margin: 0px !important;\n  padding: 3px !important;\n}\n\n.form-text {\n  color: @philips-red !important;\n}\n\n.breadCrumb {\n  &.root {\n    .d-flex();\n    .flex-row();\n    .justify-start();\n    .align-center();\n    width: 100%;\n    padding: 10px;\n  }\n\n  .item {\n    .philipsBlue();\n    text-overflow: ellipsis;\n    display: block;\n    white-space: nowrap;\n    overflow: hidden;\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 1rem;\n    font-weight: bold;\n  }\n\n  .activeItem {\n    font-weight: bold;\n  }\n}\n\n.search-bar.MuiAutocomplete-root {\n  width: 20em !important;\n  position: relative;\n  bottom: 3px;\n  right: 20px;\n  padding-top: 0.3rem;\n\n  .search-inner-text > div {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n    margin-left: 0.7vw;\n  }\n\n  .search-inner-text > div > div > button {\n    // To make the clear icon visible\n    visibility: visible !important;\n  }\n\n  .search-inner-text > div > div > svg {\n    // To set the icon in place\n    position: absolute !important;\n    top: 1.1vh !important;\n    left: 0.2vw !important;\n  }\n}\n\n.unsupported-browser {\n  display: inline-block;\n  text-align: center;\n  width: 45%;\n  height: 90%;\n  margin-left: auto;\n  margin-right: auto;\n\n  .message {\n    text-align: left;\n    padding-top: 5px !important;\n  }\n\n  .unsupported-browser-image {\n    height: 50;\n    width: 40;\n  }\n\n  .versionSupported {\n    z-index: 150000 !important;\n    padding: 10px;\n    .d-flex();\n    .flex-row();\n    .justify-center();\n    .align-center();\n\n    .browserBox {\n      .d-flex();\n      .flex-column();\n      .align-center();\n      margin: 0 2%;\n      justify-content: space-between;\n\n      img {\n        height: 35px;\n        width: 35px;\n      }\n\n      .browserDetails {\n        .d-flex();\n        .flex-column();\n      }\n    }\n  }\n}\n\n.activeIcon {\n  color: @philips-gray !important;\n  .bg-philips-blue() !important;\n}\n\n.languageContainer {\n  font-size: 1rem !important;\n  padding: 0px !important;\n  vertical-align: middle !important;\n  align-items: center !important;\n  border-radius: 0 !important;\n  width: max-content;\n}\n\n.data-table {\n  height: calc(90% - 8.6rem);\n  padding-bottom: 10px;\n  width: 60%;\n}\n\n.features-table {\n  height: calc(90% - 8.6rem);\n  width: 100%;\n\n  .recordPicker {\n    position: relative;\n    bottom: 3px;\n    padding-top: 0.3rem;\n  }\n}\n\n.alert-dialog {\n  .MuiDialog-container .MuiPaper-root {\n    min-width: 40%;\n  }\n\n  display: inline-block;\n  width: 45%;\n  height: 90%;\n  margin-left: auto;\n  margin-right: auto;\n  min-width: 30%;\n}\n\n.autocomplete-div {\n  margin-top: 0.3%;\n  flex-basis: 35%;\n}\n\n.tab-Panel {\n  height: 20px !important;\n  min-height: 20px !important;\n}\n\n.loading-message {\n  display: block;\n  text-align: center;\n  background: white;\n  padding: 50px;\n  box-shadow: 1px 1px 2px 1px grey;\n  border-radius: 3px;\n  width: 30%;\n  min-width: 30%;\n}\n\n.manage-tab-pagination {\n  align-items: center;\n  margin-top: 1rem;\n  height: 8rem;\n}\n\n.procos-pagination {\n  width: 60%;\n  align-items: center;\n}\n\n.procos-features-pagination {\n  width: 100%;\n  align-items: center;\n  padding-top: 1%;\n}\n\n.common-btn {\n  height: 2.5rem;\n  white-space: nowrap;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs {\n  .text-capitalize();\n  .align-center();\n  .justify-left();\n  .text-left();\n  min-height: 30px;\n  padding: 7px;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-tabs {\n  color: #0d5e87 !important;\n  background: rgba(199, 224, 244, 1) !important;\n  font-weight: 800 !important;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.pdm-tabs {\n  .text-capitalize();\n  .align-center();\n  .justify-center();\n  min-height: 30px;\n  padding: 7px;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.pdm-tabs {\n  color: #1474a4 !important;\n  font-weight: 800 !important;\n}\n\n.navigateTabLabel {\n  writing-mode: tb-rl;\n  height: inherit;\n  cursor: pointer;\n\n  font-size: 1.25rem;\n  white-space: nowrap;\n}\n\n.pinIcon {\n  font-size: 1.4rem !important;\n}\n\n.tabDrawerMini {\n  width: 4.5rem;\n  height: auto;\n  text-align: center;\n  background: #eeeeee;\n  z-index: 100;\n}\n\n.drawerOpen {\n  width: 200px;\n}\n\n.drawer-tab {\n  min-height: 500px !important;\n}\n\n.pdm-tab {\n  height: 32px !important;\n  min-height: 32px !important;\n}\n\n.checkbox-highlight {\n  box-shadow: inset 0px 0px 1px 1px orange;\n}\n\n.procos-tab-panel {\n  min-height: 20px !important;\n}\n\n.tabs-padding {\n  padding: 7px 15px 7px 15px;\n}\n\n.tab-icon {\n  margin-right: 5px;\n}\n\n.failed-rule {\n  max-height: 100px;\n  .p-5px();\n}\n\n.autocomplete {\n  padding: 3px !important;\n}\n\n.contents {\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.leftBar {\n  border-right: 1px solid rgba(224, 224, 224, 1);\n  width: 20%;\n  height: 100% !important;\n  overflow: hidden;\n\n  .MuiAutocomplete-inputRoot {\n    border-radius: 0;\n  }\n\n  .defaultExpandIcon {\n    color: #0062a1;\n  }\n\n  .defaultCollapseIcon {\n    color: #0078ce;\n  }\n\n  .defaultEndIcon {\n    color: @philips-gray;\n  }\n\n  .featuresTree {\n    height: 80%;\n    max-width: 100%;\n    overflow-y: auto;\n  }\n\n  .treeSearchBar {\n    .innerTextField > div {\n      // To remove unwanted padding to the search bar\n      padding-top: 0% !important;\n      padding-bottom: 0% !important;\n    }\n\n    .innerTextField > div > div > button {\n      // To make the clear icon visible\n      visibility: visible !important;\n    }\n  }\n}\n\n.rightBar {\n  width: 100% !important;\n  height: 95% !important;\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-right: 1%;\n  padding-left: 0.5%;\n}\n\n.properties-div {\n  height: 80% !important;\n  .refresh-button {\n    path {\n      font-size: 18px !important;\n    }\n  }\n}\n\n.inputFieldset {\n  box-sizing: border-box;\n  border-radius: 4px;\n  border-width: 1.5px;\n  border-color: rgba(0, 0, 0, 0.2);\n  border-style: solid;\n  width: 100%;\n  padding-bottom: 4px !important;\n  padding-left: 0.8rem !important;\n  margin-top: 10px !important;\n\n  &:hover:not(:focus):not(:focus-within) {\n    border-color: rgba(0, 0, 0, 0.87);\n  }\n\n  &:focus-within {\n    border-color: #1173a3;\n  }\n\n  & > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.6);\n    word-break: break-all;\n  }\n\n  &:focus-within > legend.inputLegend {\n    color: @philips-blue;\n  }\n\n  &:hover:not(:focus):not(:focus-within) > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.87);\n  }\n}\n\n.properties-pane-title {\n  padding-bottom: 1px !important;\n}\n\n.flow {\n  overflow: auto;\n  height: 92%;\n}\n\n.action-button {\n  display: flex;\n  height: 8%;\n  padding: 1px;\n}\n\n.toggle-switch {\n  padding-left: 1%;\n  padding-top: 0px !important;\n}\n\n.switch-field {\n  padding: 8px !important;\n  & .MuiSwitch-track {\n    border-radius: 11px;\n    &::before,\n    &::after {\n      position: absolute;\n      top: 40%;\n      transform: translateY(-50%);\n      width: 16px;\n      height: 16px;\n    }\n    &::before {\n      content: 'Y';\n      left: 17px;\n      color: white;\n    }\n    &::after {\n      content: 'N';\n      right: 8px;\n      color: white;\n    }\n  }\n  & .MuiSwitch-thumb {\n    box-shadow: none;\n    width: 16px;\n    height: 16px;\n    margin: 2px;\n  }\n}\n\n.warning-icon {\n  font-size: 1.8rem !important;\n  color: @philips-orange;\n}\n\n.defaultIcon {\n  color: hsl(51, 79%, 25%);\n  border: 2px solid hsl(51, 59%, 55%);\n  background-color: hsl(51, 89%, 95%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 56px;\n  &.empty {\n    border: none;\n    background-color: transparent;\n  }\n}\n\n.MuiDataGrid-columnSeparator--resizable {\n  cursor: e-resize !important;\n}\n\n.css-15l8jjv .MuiDataGrid-columnSeparator--resizable {\n  cursor: e-resize;\n  touch-action: none;\n}\n\n.status-inactive {\n  background: #5a5a5a;\n  color: white;\n  text-align: center;\n}\n\n.status-active {\n  background: #2e7d32;\n  color: white;\n  text-align: center;\n}\n\n.inActiveWarningMessage {\n  margin-left: 0.5em;\n  .warningMessage {\n    .warningIcon();\n    .colFlex();\n    line-height: 1.2;\n    color: @philips-orange;\n    font-size: 1rem !important;\n  }\n  .warningSize {\n    height: 100% !important;\n    width: 2em !important;\n    color: @philips-orange;\n  }\n  .warningIcon {\n    color: @philips-orange;\n    font-size: 2rem !important;\n  }\n}\n\n.navbar {\n  font-size: 12px !important;\n  line-height: 3 !important;\n}\n.navbar a {\n  color: grey;\n  text-decoration: none !important;\n}\n.navbar a.active {\n  color: @philips-blue;\n  border-bottom: 2px solid @philips-blue !important;\n  text-decoration: none !important;\n}\n\n.headerLogo {\n  cursor: pointer !important;\n}\n\n.cellWithValueAsNo {\n  background-color: pink !important;\n  color: #8b0000 !important;\n}\n\n.active-menu {\n  width: 10rem;\n}\n\n.fail-effectivity {\n  height: 150px;\n  overflow-y: auto;\n}\n\n.icon-font-size {\n  font-size: 2rem !important;\n  margin-right: 5px !important;\n}\n\n.properties-content {\n  height: 100%;\n}\n\n.header-action {\n  display: flex;\n  justify-content: flex-end;\n}\n.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.enabled {\n  pointer-events: auto;\n  opacity: 1;\n}\n\n.toast-content-default {\n  background-color: white;\n}\n\n.toast-content-success {\n  background-color: @philips-green;\n  color: black;\n}\n\n.toast-content-warning {\n  background-color: @philips-orange;\n  color: black;\n}\n\n.toast-content-error {\n  background-color: @philips-red;\n  color: black;\n}\n\n.wi-toast-content-success {\n  background-color: @philips-green;\n  color: black;\n}\n\n.effectivity-toast-content-success {\n  margin-top: 90px;\n  background-color: @philips-green;\n  color: black;\n}\n\n.effectivity-toast-content-error {\n  margin-top: 90px;\n  background-color: @philips-red;\n  color: black;\n}\n\n.absolute-right {\n  position: absolute !important;\n  right: 0;\n}\n\n.appTabs-border {\n  border-bottom: solid 1px rgba(0, 0, 0, 0.12);\n}\n\n.link {\n  .cursor-pointer();\n  text-decoration: underline !important;\n  color: blue !important;\n}\n\n.data-table-container {\n  /* Add this class to the container */\n  display: flex;\n  flex-direction: column;\n  flex: 1; /* Allow container to grow */\n  overflow: auto; /* Allow scrolling if content overflows */\n  width: 100%;\n}\n\n.data-table-container .data-table {\n  flex-grow: 1; /* Allow DataTable to grow */\n}\n\n.data-table-container .pagination-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px; /* Ensure pagination is visible */\n  padding: 1rem;\n  overflow: auto;\n}\n\n.data-table-container .pagination-container .MuiPagination-root {\n  width: 100%;\n}\n\n.manipulation-dialog {\n  width: 100%;\n  min-height: 50%;\n  height: 70%;\n  max-height: 70%;\n  max-width: 100%;\n  margin-top: 10rem;\n  z-index: 99 !important;\n}\n\n.manipulation-dialog .formActionButtons {\n  text-align: right;\n}\n\n.tabsAndActionPanel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.searchIconForColumn {\n  .rowFlex();\n  .align-center();\n}\n\n.h-3-5 {\n  height: 3.5%;\n}\n\n.headerLogoButton {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.pdmHistoryDialogStyle {\n  .paper {\n    width: 85% !important;\n    height: 110vh !important;\n    max-width: 100% !important;\n  }\n\n  .title {\n    display: flex; /* keeps first span at start in normal flow */\n    align-items: center; /* vertical centering if there's height */\n    justify-content: start;\n    gap: 4px;\n    width: 100%;\n    position: relative;\n  }\n\n  .start {\n    /* stays at the start in normal flow */\n    width: max-content;\n    min-width: max-content;\n    text-align: start;\n  }\n\n  .center {\n    width: max-content;\n    text-align: start;\n    display: flex;\n    justify-content: start;\n    text-overflow: clip;\n  }\n\n  .close {\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n    height: 100%;\n    width: max-content;\n    min-width: max-content;\n    color: white;\n  }\n  .dialogContent {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 20px !important;\n    .MuiDataGrid-root {\n      min-height: 90% !important;\n    }\n    .manage-tab-pagination {\n      margin-top: 0 !important;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n\n.historyFilterPanel {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  width: max-content !important;\n  .historyFilterContent {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    flex-wrap: wrap;\n    flex-direction: row;\n    width: max-content !important;\n    .historyFilterRow {\n      display: flex;\n      gap: 16px;\n      flex-direction: row;\n      align-items: center;\n      width: max-content !important;\n      .historyFilterFormControl {\n        min-width: 145px;\n      }\n    }\n  }\n}\n\n.color-red {\n  color: red !important;\n}\n\n.history-button {\n  path {\n    font-size: 18px !important;\n  }\n  span {\n    font-size: 12px !important;\n  }\n}\n\n.delete-button {\n  .text-capitalize();\n  color: red;\n}\n\n.autocomplete-value-mismatch {\n  .MuiOutlinedInput-notchedOutline {\n    border-color: @philips-red !important;\n  }\n\n  .MuiOutlinedInput-input {\n    color: @philips-red !important;\n    -webkit-text-fill-color: @philips-red !important;\n  }\n\n  .Mui-disabled {\n    .MuiOutlinedInput-notchedOutline {\n      border-color: @philips-red !important;\n    }\n\n    .MuiOutlinedInput-input {\n      -webkit-text-fill-color: @philips-red !important;\n    }\n  }\n\n  .MuiInputLabel-root.Mui-disabled {\n    color: @philips-red !important;\n  }\n}\n",".customToolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: min-content !important;\n}\n\n.columnsPanelTrigger {\n  min-height: min-content !important;\n  min-width: min-content !important;\n}\n\n.filterPanelTrigger {\n  min-height: min-content !important;\n  min-width: min-content !important;\n}\n\n@philips-blue: #1474a4;\n\n.category {\n  height: 80vh;\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  overflow-y: auto;\n\n  .multi-numeric-icon {\n    color: #ffa300;\n  }\n\n  .header-section {\n    margin-left: 7px;\n    width: 99%;\n    box-sizing: border-box;\n    margin-bottom: 2px;\n\n    .section-view {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n\n      .edit-view {\n        button {\n          text-transform: capitalize;\n        }\n      }\n    }\n\n    .category-header-section {\n      display: flex;\n      flex-direction: row;\n      overflow: hidden;\n      width: 100%;\n      background: rgb(242, 244, 247);\n      border-radius: 1px 1px 0px 0px;\n      border: 1px solid rgb(221, 225, 233);\n      height: 35px;\n      max-height: 35px;\n      font-size: 12px !important;\n      align-items: center;\n\n      .breacrum-header-section {\n        width: 50%;\n        display: flex;\n        align-items: center;\n        .css-1v5z4dq-MuiPaper-root-MuiCard-root {\n          border: 0px;\n        }\n        button {\n          padding-top: 0px;\n          padding-bottom: 0px;\n          width: 100px;\n          margin-right: 5px;\n          margin-left: 0px;\n          height: 33px;\n          border-radius: 2px;\n          text-transform: capitalize;\n        }\n\n        .MuiPaper-root.MuiCard-root {\n          border: 0px;\n        }\n\n        nav {\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n\n  .categories-container {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 20px;\n    margin-left: 7px;\n    width: 99%;\n    flex: 1; // Make it take available space\n    min-height: 369px; // Minimum height\n\n    .categories-panel {\n      width: 560px;\n      display: flex;\n      flex-direction: column;\n\n      h3 {\n        margin-bottom: 8px;\n      }\n\n      .categories-list {\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        overflow-y: auto; // Add vertical scroll\n        overflow-x: hidden;\n        flex: 1; // Take available height\n        max-height: calc(70vh - 150px); // Calculate maximum height\n      }\n    }\n\n    .droppable-zones {\n      display: flex;\n      gap: 20px;\n      flex: 1;\n\n      // Make each droppable zone take equal width\n      > div {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n      }\n    }\n  }\n\n  .breadcrumb-card-section {\n    nav {\n      display: flex;\n      align-items: center;\n      width: 100%;\n\n      a {\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        transition: color 0.2s ease;\n        font-size: 14px;\n        padding: 4px 6px;\n        border-radius: 4px;\n        background-color: #f2f4f7;\n\n        &.active {\n          color: black;\n          font-weight: 500;\n        }\n\n        &.not-active {\n          color: #595959;\n\n          &:hover {\n            color: #333;\n            background-color: rgba(0, 0, 0, 0.04);\n          }\n        }\n      }\n\n      .MuiSvgIcon-root {\n        color: #999;\n        margin: 0 8px;\n      }\n    }\n  }\n\n  .category-content {\n    display: flex;\n    flex: 1;\n    height: calc(100% - 100px);\n    position: relative;\n  }\n\n  .left-pane,\n  .middle-pane,\n  .right-pane {\n    position: relative;\n  }\n\n  .left-pane {\n    --pane-width: 30%;\n    width: var(--pane-width);\n    min-width: 200px;\n    height: 100%;\n    border: 1px solid #eee;\n    border-radius: 4px;\n    margin-left: 8px;\n  }\n\n  .middle-pane {\n    --pane-width: 35%;\n    width: var(--pane-width);\n    min-width: 200px;\n    height: 96%;\n  }\n\n  .right-pane {\n    --pane-width: 35%;\n    width: var(--pane-width);\n    min-width: 200px;\n    height: 96%;\n  }\n\n  .resize-hor {\n    resize: horizontal;\n  }\n\n  .disabled-view {\n    opacity: 0.6;\n    pointer-events: none;\n  }\n\n  .assigned-section-header,\n  .unassingned-section-header {\n    border-bottom: 2px solid #eee;\n    padding-left: 4%;\n    font-weight: bold;\n  }\n}\n\n// Sortable Category Styles\n.category-item {\n  position: relative;\n  &.over:not(.invalid) {\n    // Only show border, no background fill\n    border: 2px solid #1474a4;\n  }\n\n  &.invalid {\n    // Only show red border, no background\n    border: 2px solid #ef4444;\n    // Ensure no other border styles interfere\n    outline: none;\n  }\n\n  &.hover:not(.invalid):not(.over) {\n    > div:first-child {\n      outline: 2px dashed #1474a4;\n      // No background fill\n    }\n  }\n  .category-row {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .category-content {\n    width: 100%;\n    position: relative;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    &.selected {\n      // Only highlight the text, not the whole box\n      background: transparent;\n\n      // The text and icons will be highlighted\n      .feature-name,\n      .action-button {\n        color: #1474a4;\n        font-weight: 500;\n      }\n\n      // Feature icon (folder icon) should turn blue when selected\n      .drag-handle .feature-icon .category-icon {\n        color: #1474a4 !important;\n      }\n\n      // Override multi-numeric icon color when selected\n      .drag-handle .feature-icon .category-icon.multi-numeric-icon {\n        color: #ffa300 !important;\n      }\n    }\n\n    // Highlight subcategories when their parent is selected\n    &.parent-selected {\n      .feature-name {\n        color: #1474a4;\n        font-weight: 500;\n      }\n\n      // Feature icon (folder icon) should turn blue when parent is selected\n      .drag-handle .feature-icon .category-icon {\n        color: #1474a4 !important;\n      }\n\n      .drag-handle .feature-icon .category-icon.multi-numeric-icon {\n        color: #ffa300 !important;\n      }\n    }\n  }\n\n  .category-title {\n    display: flex;\n    align-items: center;\n    flex: 1;\n  }\n  .drag-handle {\n    display: flex;\n    align-items: center;\n    flex: 1;\n  }\n  .feature-name {\n    margin-left: 6px;\n  }\n  .category-actions-wrapper {\n    display: flex;\n    align-items: center;\n    margin-left: 8px;\n  }\n  .subcategories {\n    margin-left: 20px;\n  }\n}\n\n// Droppable Zone Styles\n.droppable-zone {\n  flex: 1;\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n  height: 98%;\n\n  h3 {\n    margin-bottom: 8px;\n\n    &.highlighted {\n      color: #1474a4;\n    }\n  }\n\n  .drop-area {\n    padding: 15px;\n    background: #fff;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow-y: auto;\n    z-index: 1;\n\n    .items-container {\n      flex: 1;\n      overflow-y: auto;\n    }\n\n    &.over:not(.invalid),\n    &[data-highlight='true']:not([data-invalid='true']) {\n      border: 2px solid #1474a4 !important;\n      border-style: solid !important;\n      background: transparent;\n      z-index: 2;\n      box-shadow: 0 0 0 1px rgba(20, 116, 164, 0.3);\n    }\n\n    &.invalid,\n    &[data-invalid='true'] {\n      border: 2px solid #ef4444 !important;\n      border-style: solid !important;\n      background: transparent;\n      z-index: 3;\n      box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.3);\n    }\n\n    .empty-message {\n      color: #666;\n      font-style: italic;\n    }\n  }\n}\n\n// Draggable/Sortable Item Styles\n.draggable-sortable-item {\n  &.dragging {\n    cursor: grabbing;\n    opacity: 0.4; // Lower opacity for the original item\n    background-color: #f0f6ff !important;\n    border: 1px dashed #ccc;\n    box-shadow: none;\n    z-index: 1000 !important; // Ensure it's on top\n    pointer-events: none; // Allow drops to pass through\n  }\n  &.sortable {\n    border-radius: 4px;\n    cursor: grab;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n\n    .item-content {\n      flex: 1;\n      display: flex;\n      align-items: center;\n      overflow: hidden;\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.5;\n      letter-spacing: 0.00938em;\n\n      .item-description {\n        margin-right: 4px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .item-code {\n        flex-shrink: 0;\n        white-space: nowrap;\n        color: #666;\n      }\n    }\n\n    .item-actions {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      .drag-handle {\n        color: #666;\n        font-size: 14px;\n      }\n    }\n  }\n\n  &.draggable {\n    border-radius: 4px;\n    cursor: grab;\n    display: flex;\n    align-items: center;\n    .item-content {\n      margin-left: 8px;\n      flex: 1;\n      display: flex;\n      align-items: center;\n      overflow: hidden;\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.5;\n      letter-spacing: 0.00938em;\n\n      .item-description {\n        margin-right: 4px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .item-code {\n        flex-shrink: 0;\n        white-space: nowrap;\n        color: #666;\n      }\n    }\n  }\n\n  &.disabled {\n    opacity: 0.6;\n    cursor: default;\n    pointer-events: none;\n    color: #888;\n\n    &.sortable {\n      background: #f7f9ff;\n    }\n\n    &.draggable {\n      background: #f5f5f5;\n    }\n  }\n\n  &.inactive {\n    opacity: 0.7;\n    cursor: default;\n    pointer-events: none;\n\n    .strikethrough {\n      text-decoration: line-through;\n    }\n  }\n}\n\n// Add Category Dialog Styles\n.common-dialog-style {\n  .MuiPaper-root {\n    .MuiDialogTitle-root {\n      background: #1474a4;\n      color: #fff;\n      padding: 7px;\n      padding-left: 23px;\n      cursor: move;\n    }\n\n    .MuiBox-root {\n      width: 100%;\n    }\n  }\n}\n.add-category-dialog {\n  .MuiPaper-root {\n    width: 80%;\n  }\n}\n// Custom drag preview\n.drag-preview {\n  padding: 2px 2px;\n  border-radius: 4px;\n  background: #1474a4;\n  color: rgb(255, 255, 255);\n  font-weight: 500;\n  font-size: 12px;\n  pointer-events: none;\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  .item-code {\n    opacity: 0.8;\n    font-size: 12px;\n  }\n}\n\n// Ensure drag overlay is always on top\n[data-dnd-overlay] {\n  z-index: 9999 !important;\n}\n\n.drag-overlay-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n\n  .item-name {\n    font-weight: 500;\n  }\n\n  .item-code {\n    color: #666;\n  }\n}\n\n.auto-complete-searchbar {\n  margin-top: 16px;\n  display: flex;\n}\n\n.auto-complete-search-input {\n  flex-basis: 90%;\n\n  .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n    border-radius: 4px 0px 0px 4px !important;\n  }\n}\n\n.auto-complete-search-button {\n  background: white;\n  border-radius: 0px 4px 4px 0px !important;\n  border: solid 2px #e2e2e2 !important;\n  border-left: none !important;\n}\n\n.auto-complete-search-icon {\n  font-size: 25px !important;\n  color: @philips-blue !important;\n}\n\n.css-xnywni-MuiFormLabel-root-MuiInputLabel-root {\n  top: 20px !important;\n  position: relative !important;\n}\n\n.css-196bwzp-MuiPaper-root-MuiCard-root {\n  background-color: #f2f4f7 !important;\n}\n\n.css-1umw9bq-MuiSvgIcon-root {\n  width: 16px !important;\n  height: 0.9em !important;\n}\n\n// Large header icon style for header action icons\n.header-large-icon {\n  font-size: 1.7rem !important;\n  line-height: 1;\n}\n\n.icon-with-label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-right: 24px;\n}\n\n.edit-view {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n}\n\n.icon-helper-text {\n  font-size: 0.95rem;\n  color: #1474a4;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n}\n\n.css-nykz7-MuiTreeItem-content {\n  padding: 4px 8px 0px 0px !important;\n  gap: 0px !important;\n}\n\n.css-nykz7-MuiTreeItem-content.Mui-selected {\n  background-color: revert !important;\n}\n\n.category-wrapper {\n  padding-left: 0;\n}\n\n.category-wrapper[data-section-depth] {\n  padding-left: calc(var(--category-depth, 0) * 20px);\n}\n\n.css-fojsl4-MuiTreeItem-content {\n  gap: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
